// Mednos Plattform-Helfer — gemeinsame Auth-Server-Calls und generische
// DOM-Bausteine für die Plattform-Abschnitte des Profil-Panels.
//
// Wird importiert von:
//   - platform/shared/twofa-section.js
//   - platform/shared/admin-overlay.js
//   - platform/shared/profile-panel.js (nur ppButton, für den Admin-Button)

// ── Plattform-Calls (Admin, 2FA) ───────────────────────────────────────────
// Gehen direkt an den Auth-Server, nicht über das App-Backend: die Routen
// gibt es nur dort, und CORS erlaubt beiden App-Origins Credentials.
const AUTH_ORIGIN = 'https://mednos.eu';

export async function authApi(path, opts = {}) {
  try {
    const res = await fetch(AUTH_ORIGIN + path, { credentials: 'include', ...opts });
    return { status: res.status, body: await res.json().catch(() => ({})) };
  } catch {
    return { status: 0, body: {} }; // Netzwerkfehler — Auth-Server nicht erreichbar
  }
}

export function authJsonPost(path, payload) {
  return authApi(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

// DOM-Helfer im Panel-Stil. Serverdaten laufen ausschließlich über
// textContent — siehe den XSS-Hinweis am Kopf von profile-panel.js.
export function ppLabel(text) {
  const el = document.createElement('span');
  el.className = 'profile-panel__label';
  el.textContent = text;
  return el;
}
export function ppStatus(text, isErr) {
  const el = document.createElement('span');
  el.className = 'profile-panel__status' + (isErr ? ' profile-panel__status--err' : '');
  el.textContent = text;
  return el;
}
export function ppHint(text) {
  const el = document.createElement('span');
  el.className = 'profile-panel__hint';
  el.textContent = text;
  return el;
}
export function ppButton(text, onClick) {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'profile-panel__btn';
  b.textContent = text;
  b.addEventListener('click', onClick);
  return b;
}
// Wie ppButton, aber als unterstrichener Textlink (z. B. "Abbrechen" /
// "Zurück" in den 2FA-Formularen).
export function ppLink(text, onClick) {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'profile-panel__link';
  b.textContent = text;
  b.addEventListener('click', onClick);
  return b;
}
